import { useState, useEffect } from 'react';
import { settingsService } from '../services/settingsService';

/**
 * Hook som leser innstillingen 'warehouseTransfer.showToLocationSuggestions'.
 *
 * Styrer om operatøren får forslag til til-lokasjon i lokasjonsflytt:
 * - lokasjoner som allerede har saldo for varen (vises automatisk)
 * - put-away-kandidater på forespørsel («Finn gode plasseringer»-knapp)
 *
 * Oppløsning følger hierarkiet Profile → System → Default via getEffectiveSetting.
 *
 * Default: true (forslag vises med mindre tenant/profil eksplisitt slår dem av).
 */
export function useShowTransferToLocationSuggestions(): boolean {
  const [show, setShow] = useState<boolean>(true);

  useEffect(() => {
    let cancelled = false;

    const loadSetting = async () => {
      try {
        const setting = await settingsService.getEffectiveSetting('warehouseTransfer.showToLocationSuggestions');
        if (!cancelled) {
          if (setting && setting.currentValue !== null && setting.currentValue !== undefined) {
            const val = setting.currentValue.toString().toLowerCase();
            setShow(val === 'true' || val === '1' || val === 'ja');
          } else {
            // Ingen verdi satt → bruk default (vis forslag)
            setShow(true);
          }
        }
      } catch (err) {
        console.warn('Could not load warehouseTransfer.showToLocationSuggestions setting, defaulting to true:', err);
        if (!cancelled) {
          setShow(true);
        }
      }
    };

    loadSetting();

    return () => { cancelled = true; };
  }, []);

  return show;
}
